import React, { useCallback, useEffect, useState } from "react";
import { DateRangePicker } from 'react-date-range';
import { Button, Dropdown, Form, Input, Menu, Modal, PageHeader, Select, Table, Tag } from "antd";
import { crud } from "@/redux/crud/actions";
import { useDispatch, useSelector } from "react-redux";
import { selectItemById, selectListItems, selectReportItems, selectUpdatedItem } from "@/redux/crud/selectors";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined, EyeOutlined } from "@ant-design/icons";
import { Link, Redirect, useHistory } from "react-router-dom";
import uniqueId from "@/utils/uinqueId";
import SearchItem from "@/components/SearchItem";
import HeaderContent from "@/layout/HeaderContent";
import Loading from "@/components/Loading";
import { API_BASE_URL } from "@/config/serverApiConfig";
import axios from "axios";
import TextArea from "antd/lib/input/TextArea";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { addDays } from 'date-fns';
import dateFormat from 'dateformat';
import { FunnelChart } from "recharts";
import { CSVLink, CSVDownload } from "react-csv";

function Report() {
  const entity = "generate-report";
  const searchConfig = {
    displayLabels: ["email"],
    searchFields: "fname,lname,email",
    outputValue: "_id",
  };
  const { current, isLoading, isSuccess } = useSelector(selectUpdatedItem);

  let [note, setNote] = useState("");
  const [loadForm, setLoadForm] = useState(true);
  const [loadFormView, setLoadFormView] = useState(true);
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);

  let [data, setData] = useState([]);
  let [edit_id, set_edit_id] = useState(0);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [confirmLoadingView, setConfirmLoadingView] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const [form] = Form.useForm();

  const [isModalVisible, setIsModalVisible] = useState(false);
  let history = useHistory();
  const panelTitle = "Reports ";
  const dataTableTitle = "Reports";
  const entityDisplayLabels = ["company"];

  const { result: listResult, isLoading: listIsLoading } = useSelector(selectListItems);
  const { pagination, items, itemsTwo } = listResult;

  const handelDataTableLoad = useCallback((pagination) => {
    dispatch(crud.list(entity, pagination.current));
  }, [dispatch, entity]);

  const onSubmit = () => {
    dispatch(crud.update(entity, edit_id, form.getFieldValue()));
    dispatch(crud.list(entity, pagination.current));
    setVisible(false);
  };

  const [isGenerate, setIsGenerate] = useState(false);
  const [isGenerateTwo, setIsGenerateTwo] = useState(false);

  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ]);

  const onSubmitAdd = () => {
    console.log(formAdd.getFieldValue());
    dispatch(crud.create(entity, formAdd.getFieldValue()));
    dispatch(crud.list(entity, pagination.current));
    setVisibleAdd(false);
  };

  const ADD_NEW_ENTITY = "View Pending Approval User";
  const DATATABLE_TITLE = "Business Directory List";
  const ENTITY_NAME = "Business Directory";
  const CREATE_ENTITY = "Create Business Directory";
  const UPDATE_ENTITY = "Update Business Directory";

  const readColumns = [
    {
      title: "No of Requests Listing",
      dataIndex: "requests",
    },
    {
      title: "Name Of Company",
      dataIndex: "companyName",
    },
  ];

  const dataTableColumnsTwo = [
    {
      title: "User Name",
      render: (row) => (
        <>
          {Array.isArray(row.listingRequest) &&
            row.listingRequest.map((item, idx) => <p key={idx}>{item.name}</p>)}
        </>
      ),
    },
    {
      title: "Category One",
      render: (row) => (
        <>
          {Array.isArray(row.listingRequest) &&
            row.listingRequest.map((item, idx) => (
              <div key={idx}>
                <p>{item.category_one_name}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Category Two",
      render: (row) => (
        <>
          {Array.isArray(row.listingRequest) &&
            row.listingRequest.map((item, idx) => (
              <div key={idx}>
                <p>{item.category_two_name ? item.category_two_name : ""}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Category Three",
      render: (row) => (
        <>
          {Array.isArray(row.listingRequest) &&
            row.listingRequest.map((item, idx) => (
              <div key={idx}>
                <p>{item.category_three_name ? item.category_three_name : ""}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Date",
      render: (row) => (
        <>
          {Array.isArray(row.listingRequest) &&
            row.listingRequest.map((item, idx) => (
              <div key={idx}>
                <p>
                  {item.createdAt
                    ? dateFormat(item.createdAt, "mmmm dS, yyyy")
                    : ""}
                </p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Time",
      render: (row) => (
        <>
          {Array.isArray(row.listingRequest) &&
            row.listingRequest.map((item, idx) => (
              <div key={idx}>
                <p>
                  {item.createdAt
                    ? dateFormat(item.createdAt, "h:MM:ss TT")
                    : ""}
                </p>
              </div>
            ))}
        </>
      ),
    },
  ];

  const dataTableColumns = [
    {
      title: "Name of Company",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => <p key={idx}>{item.companyName}</p>)}
        </>
      ),
    },
    {
      title: "Name of POC",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>{item.nameOfPoc}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Email of POC",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>{item.emailOfPoc}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Phone of POC",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>{item.mobileOfPoc}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Website",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>{item.businessWebsite}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Phone",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>{item.businessPhone}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Country",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>{item.country}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "City",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>{item.city}</p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Business Intro",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>
                  {item.businessIntro
                    ? item.businessIntro.substring(0, 50) + "..."
                    : ""}
                </p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Date",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>
                  {item.createdAt
                    ? dateFormat(item.createdAt, "mmmm dS, yyyy")
                    : ""}
                </p>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Time",
      render: (row) => (
        <>
          {Array.isArray(row.business) &&
            row.business.map((item, idx) => (
              <div key={idx}>
                <p>
                  {item.createdAt
                    ? dateFormat(item.createdAt, "h:MM:ss TT")
                    : ""}
                </p>
              </div>
            ))}
        </>
      ),
    },
  ];

  useEffect(() => {
    if (isSuccess) {
      dispatch(crud.resetAction("update"));
      dispatch(crud.generateReport(entity, state[0]));
    }
  }, [isSuccess, dispatch, entity, state]);

  useEffect(() => {
    dispatch(crud.generateReport(entity, state[0]));
  }, [dispatch, entity, state]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(crud.resetAction("update"));
      dispatch(crud.generateReportTwo(entity, state[0]));
    }
  }, [isSuccess, dispatch, entity, state]);

  useEffect(() => {
    dispatch(crud.generateReportTwo(entity, state[0]));
  }, [dispatch, entity, state]);

  const config = {
    entity,
    panelTitle,
    dataTableTitle,
    ENTITY_NAME,
    CREATE_ENTITY,
    ADD_NEW_ENTITY,
    UPDATE_ENTITY,
    DATATABLE_TITLE,
    readColumns,
    dataTableColumns,
    searchConfig,
    entityDisplayLabels,
  };

  let [category, setCategory] = useState([]);
  useEffect(() => {
    axios(`${API_BASE_URL}category/getCategory`)
      .then((res) => {
        setCategory(res.data.data);
      })
      .catch((err) => {});
  }, []);

  function onChange({ target: { value } }) {
    setNote(value);
  }
  const handleSelect = (item) => {
    setState([item.selection]);
  };

  
  const generateReport = () => {
    dispatch(crud.generateReport(entity, state[0]));
    setIsGenerate(true);
    setIsOpen(false);
  };

  const generateReportTwo = () => {
    dispatch(crud.generateReportTwo(entity, state[0]));
    setIsGenerateTwo(true);
    setIsOpenTwo(false);
  };

  let csvData = [];
  if (isGenerate && items && Array.isArray(items) && items[0] && Array.isArray(items[0].business)) {
    csvData = items[0].business.map((item) => {
      return {
        "Business Name": item.companyName,
        "Name of POC": item.nameOfPoc,
        "Email of POC": item.emailOfPoc,
        "Phone of POC": item.mobileOfPoc
          ? item.mobileOfPoc.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
          : "",
        Website: item.businessWebsite,
        Phone: item.businessPhone
          ? item.businessPhone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
          : "",
        Country: item.country,
        City: item.city,
        "Business Intro": item.businessIntro,
        Date: item.createdAt ? dateFormat(item.createdAt, "mmmm dS, yyyy") : "",
        Time: item.createdAt ? dateFormat(item.createdAt, "h:MM:ss TT") : "",
      };
    });
  }

  let csvDataTwo = [];
  if (isGenerateTwo && itemsTwo && Array.isArray(itemsTwo) && itemsTwo[0] && Array.isArray(itemsTwo[0].listingRequest)) {
    csvDataTwo = itemsTwo[0].listingRequest.map((item) => {
      return {
        "User Name": item.name,
        "Category One": item.category_one_name,
        "Category Two": item.category_two_name ? item.category_two_name : "",
        "Category Three": item.category_two_name
          ? item.category_three_name
          : "",
        Date: item.createdAt ? dateFormat(item.createdAt, "mmmm dS, yyyy") : "",
        Time: item.createdAt ? dateFormat(item.createdAt, "h:MM:ss TT") : "",
      };
    });
  }

  const [isOpen, setIsOpen] = useState(false);
  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  const [isOpenTwo, setIsOpenTwo] = useState(false);
  const onToggleTwo = () => {
    setIsOpenTwo(!isOpenTwo);
  };

  return (
    <>
      <HeaderContent />
      <PageHeader
        onBack={() => window.history.back()}
        title={dataTableTitle}
        ghost={false}
        style={{
          padding: "20px 10px",
        }}
      ></PageHeader>

      <div className="container btn-center">
        <Button type="primary" size="large" onClick={onToggle}>
          {isOpen ? "Close Date" : "Open Date"}
        </Button>
      </div>
      {isOpen && (
        <>
          <DateRangePicker
            onChange={(item) => handleSelect(item)}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={state}
            direction="horizontal"
          />
          <div className="container btn-generate">
            <Button type="primary" size="large" onClick={generateReport}>
              Generate
            </Button>
          </div>
        </>
      )}

      <div className="table">
        <Loading isLoading={isLoading}>
          <CSVLink
            style={{
              background: "#9d7652",
              color: "#fff",
              marginRight: "20px",
            }}
            className="btn float-end"
            data={csvData}
          >
            Download CSV
          </CSVLink>
          <h3>Business Listings </h3>
          <Table
            columns={dataTableColumns}
            rowKey={(item) => item._id}
            dataSource={items}
            pagination={true}
            onChange={handelDataTableLoad}
            scroll={{ x: 1500 }}
          />
        </Loading>
      </div>
      <br />
      <div className="table">
        <Loading isLoading={isLoading}>
          <div className="container btn-center">
            <Button type="primary" size="large" onClick={onToggleTwo}>
              {isOpenTwo ? "Close Date" : "Open Date"}
            </Button>
          </div>
          {isOpenTwo && (
            <>
              <DateRangePicker
                onChange={(item) => handleSelect(item)}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={2}
                ranges={state}
                direction="horizontal"
              />
              <div className="container btn-generate">
                <Button
                  type="primary"
                  size="large"
                  onClick={generateReportTwo}
                >
                  Generate
                </Button>
              </div>
            </>
          )}
          <CSVLink
            style={{
              background: "#9d7652",
              color: "#fff",
              marginRight: "20px",
            }}
            className="btn float-end"
            data={csvDataTwo}
          >
            Download CSV
          </CSVLink>
          <h3>Request Listings </h3>
          <Table
            columns={dataTableColumnsTwo}
            dataSource={itemsTwo}
            pagination={true}
            onChange={handelDataTableLoad}
            scroll={{ x: 1500 }}
          />
        </Loading>
      </div>
    </>
  );
}

export default Report;
